import clsx from 'clsx'

import { Warning } from '@/components/Warning'

import { useEntry } from '../Theme.hooks'
import { ThemeRelatedStyle } from '../ThemeRelatedStyle/ThemeRelatedStyle'

type Props = {
	className?: string
}

export const ThemeStyles = ({ className }: Props) => {
	const entry = useEntry()

	if ('error' in entry) {
		return <Warning className={className}>{entry.error}</Warning>
	}

	if (!entry.data) return null

	return (
		<section className={clsx('w-full', className)}>
			<div className="flex flex-col lg:flex-row">
				{/* About the theme */}
				<div className="w-full">
					{/* Theme styles */}
					<h2 className="text-lg font-medium mb-5">
						Includes {entry.data.related?.length} style{entry.data.related?.length! > 1 && 's'}
					</h2>
					<div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
						{entry.data.related?.map((related) => (
							<ThemeRelatedStyle key={related} relatedId={related} />
						))}
					</div>
				</div>
			</div>
		</section>
	)
}
